import { User } from 'lucide-react'
import { useSearchParams } from 'react-router'

import { CopyQuotesLinkButton } from '@/components/quotes/CopyQuotesLinkButton'
import { NavBar } from '@/routes/Public/marketing/components/NavBar'
import { ProductFlowNav } from '@/routes/Public/marketing/components/ProductFlowNav'
import { AccountNavDemo } from '../AccountNavDemo'
import { DEMO_APPLICATION_ID, MATCHED_BROKER, NAV_LINKS } from '../navFixtures'

export type NavFrameVariant = 'matched-broker' | 'matched-broker-cart' | 'no-broker-cart' | 'site' | 'account'

/**
 * One nav variant rendered alone, for the design system to embed in a
 * phone-width iframe — `md:` breakpoints resolve against the iframe's own
 * viewport, which is the only way to show the real mobile nav on a desktop page.
 */
export function NavFrame() {
  const [searchParams] = useSearchParams()
  const variant = (searchParams.get('variant') ?? 'matched-broker') as NavFrameVariant

  if (variant === 'account') return <AccountNavDemo />

  if (variant === 'site') {
    return (
      <NavBar
        theme="light"
        navLinks={NAV_LINKS}
        phoneNumber="(770) 765-0331"
        utilityLinks={[{ label: 'Login', icon: <User />, href: '#' }]}
        ctaLabel="Get your quotes"
        ctaHref="#"
        disableScrollHide
      />
    )
  }

  return (
    <ProductFlowNav
      disableScrollHide
      hideLogin={variant === 'no-broker-cart'}
      containerAligned
      matchedBroker={variant === 'no-broker-cart' ? undefined : MATCHED_BROKER}
      allowBrokerNote
      cartCount={variant === 'matched-broker' ? undefined : 2}
      rightAction={<CopyQuotesLinkButton applicationId={DEMO_APPLICATION_ID} />}
    />
  )
}
